export const COMPONENT_FORM_INIT = 'COMPONENT_FORM_INIT'
export const COMPONENT_FORM_ON_SUBMIT = 'COMPONENT_FORM_ON_SUBMIT'
export const COMPONENT_FORM_ON_SUBMIT_DONE = 'COMPONENT_FORM_ON_SUBMIT_DONE'